import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    category: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    categoryTitle: {
      paddingTop: theme.spacing(),
      paddingBottom: theme.spacing(),
      paddingLeft: theme.spacing(2),
      display: 'flex',
    },
    count: {
      color: theme.palette.primary.main,
    },
    icon: {
      '& svg': {
        fontSize: '20px',
      },
      display: 'flex',
      marginRight: theme.spacing(),
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    listCategory: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    dialogContentRoot: {
      padding: theme.spacing(0, 1, 1, 1),
    },
  };
};
